export const studioKeys = {
  partProjects: id => ["projects", {length: 8, id}],
  projects: id => ["projects", id],
  partWorlds: id => ["worlds", {length: 8, id}],
  worlds: id => ["worlds", id],
  world: params => ["world", params],
  template: ["template"],
};
